import { jwtDecode } from "jwt-decode";
export function isValidToken(token) {
    const decoded = jwtDecode(token);
    const date = new Date(decoded.exp * 1000);
    if (date < new Date()) {
        return false;
    }
    return true;
}